@let offer = upsellOffer$ | async;

@if (offer) {
  <div class="upsell-container flex flex--space-between flex--wrap mr-small-y" data-testid="upsell-promotion-container">
    <ng-container
      [ngTemplateOutlet]="fareFamilyOption"
      [ngTemplateOutletContext]="{
        fareFamily: offer.currentOffer,
        price: offer.currentOffer.totalPrice,
        benefits: currentBenefits$ | async,
        currentSelection: true,
      }"
    />
    <ng-container
      [ngTemplateOutlet]="fareFamilyOption"
      [ngTemplateOutletContext]="{
        fareFamily: offer.upsellOffer,
        price: offer.upsellOffer.totalPriceDifference,
        benefits: newBenefits$ | async,
        currentSelection: false,
      }"
    />
  </div>
}

<ng-template
  #fareFamilyOption
  let-fareFamily="fareFamily"
  let-price="price"
  let-benefits="benefits"
  let-currentSelection="currentSelection"
>
  <div
    class="flex flex--column upsell-tile rounded-large border nordic-blue-100-border overflow-hidden"
    [attr.data-testid]="`upsell-promotion-${currentSelection ? 'current' : 'new'}`"
  >
    <div class="font-body-1 bold-type white-text pr-xsmall" [ngStyle]="{ backgroundColor: fareFamily.brandColor }">
      <div class="flex flex--middle">
        <span data-testid="upsell-promotion-brandName">{{ fareFamily.brandName }}</span>
        <span data-testid="upsell-promotion-price" class="font-heading-4 ps-medium-l"
          >{{ !currentSelection && +price.amount > 0 ? '+' : '' }} {{ price | finPrice }}</span
        >
      </div>
      <span class="font-body-2">{{ 'upsellPromotion.totalPriceInfo' | finLocalization }}</span>
    </div>
    <div class="flex-1 ps-xxsmall-x font-body-2">
      <fcom-tag data-testid="upsell-promotion-avios" class="ms-small-l ms-small-t">
        <fcom-icon class="ms-xxsmall-r icon-small" [name]="SvgLibraryIcon.AVIOS_CURRENCY" />
        @if (fareFamily?.totalAvios) {
          <span>
            {{ 'avios.collectPointsTag' | finLocalization: { points: fareFamily.totalAvios?.toLocaleString() } }}
          </span>
        } @else {
          <span>{{ 'avios.collectUndefinedPoints' | finLocalization }}</span>
        }
      </fcom-tag>
      <div class="ms-small-b">
        <fin-benefit
          *ngFor="let benefit of benefits; let first = first"
          class="block ps-small-x"
          [benefit]="benefit"
          [enableBenefitChanges$]="true | finToObservable"
          [ngClass]="{
            'ps-xsmall-t ps-xxsmall-b': first,
            'ps-xxsmall-y': !first,
          }"
        />
      </div>
    </div>
    @if (currentSelection) {
      <div class="flex flex--self-center ps-small" data-testid="upsell-promotion-selected">
        <fcom-icon class="flex--nogrow flex--self-center icon-medium" [name]="SvgLibraryIcon.CHECKMARK" />
        <span class="text font-body-1 bold-type ps-xsmall-l ps-xsmall-y">{{
          'upsellPromotion.selected' | finLocalization
        }}</span>
      </div>
    } @else {
      <fcom-button
        data-testid="upsell-promotion-change-to-classic"
        class="ps-small"
        [text]="'upsellPromotion.changeToClassic' | finLocalization"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [mode]="ButtonMode.FILL"
        [aria]="{ label: 'actions.confirm' | finLocalization, role: 'button' }"
        (clickBtn)="confirmUpsell.emit()"
      />
    }
  </div>
</ng-template>
